import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { Pagination } from 'src/interfaces/general';
import { RootState } from 'src/store/index';
import { selectRolesWithSearch } from 'src/store/model/role';

export type State = {
  loading: boolean;
  search: SearchParams.User;
  pagination: Pagination;
  searchData: Model.User[];
};

export const adapter = createEntityAdapter<Model.User>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'directory',
  initialState: adapter.getInitialState<State>({
    loading: false,
    search: {},
    searchData: [],
    pagination: {
      next_page: 0,
      total_pages: 0,
      current_page: 0,
      item_to: 0,
      limit: 0,
      item_from: 0,
      previous_page: 0,
      total_items: 0,
    },
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.User[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.User>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    updateSearch(
      state,
      action: PayloadAction<{ search: SearchParams.User; data: Model.User[] }>,
    ) {
      state.search = action.payload.search;
      state.searchData = action.payload.data;
    },
    updatePagination(state, action: PayloadAction<Pagination>) {
      state.search = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.directory,
);

export const selectUsersWithSearch = createSelector(
  (state: RootState) => state.model.directory,
  selector.selectAll,
  selectRolesWithSearch,
  ({ search, pagination, entities, searchData }, users, { role_id }) => {
    if (search.q) {
      return searchData;
    }
    if (role_id) {
      return users.filter((u) => u.roles.map((r) => r.id).includes(role_id!));
    }
    return users;
  },
);

export { reducer };
export default actions;
